var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect2, _path22, _path23, _path24, _g, _path25, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.787109,
    y: 0.53125,
    width: 350,
    height: 233,
    fill: "#33837E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.252 143.816C239.252 140.503 241.938 137.816 245.252 137.816H252.992C256.306 137.816 258.992 140.503 258.992 143.816V154.686C258.992 158 256.306 160.686 252.992 160.686H245.252C241.938 160.686 239.252 158 239.252 154.686V143.816Z",
    fill: "#191244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.094 143.816C286.094 140.503 288.78 137.816 292.094 137.816H299.834C303.147 137.816 305.834 140.503 305.834 143.816V154.686C305.834 158 303.147 160.686 299.834 160.686H292.094C288.78 160.686 286.094 158 286.094 154.686V143.816Z",
    fill: "#191244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.672 74.3594C232.672 69.9411 236.254 66.3594 240.672 66.3594H304.415C308.834 66.3594 312.415 69.9411 312.415 74.3594V145.722C312.415 150.14 308.834 153.722 304.415 153.722H240.672C236.254 153.722 232.672 150.14 232.672 145.722V74.3594Z",
    fill: "#8F87F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304.415 66.3594H240.672C236.254 66.3594 232.672 69.9411 232.672 74.3594V79.4124L290.184 153.722H304.415C308.834 153.722 312.415 150.14 312.415 145.722V74.3594C312.415 69.9411 308.834 66.3594 304.415 66.3594Z",
    fill: "#353071"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.672 130.523H312.415V133.79H232.672V130.523Z",
    fill: "#353071"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M312.415 133.79V130.523H272.242L274.701 133.79H312.415Z",
    fill: "#120E47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.254 77.7109C239.254 75.5018 241.045 73.7109 243.254 73.7109H301.834C304.043 73.7109 305.834 75.5018 305.834 77.7109V103.772C305.834 105.981 304.043 107.772 301.834 107.772H243.254C241.045 107.772 239.254 105.981 239.254 103.772V77.7109Z",
    fill: "#C3CCFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301.834 73.7109H243.254C241.045 73.7109 239.254 75.5018 239.254 77.7109V86.5306C239.254 87.4189 239.55 88.2818 240.094 88.9834L253.478 106.225C254.236 107.201 255.402 107.772 256.638 107.772H301.834C304.043 107.772 305.834 105.981 305.834 103.772V77.7109C305.834 75.5018 304.043 73.7109 301.834 73.7109Z",
    fill: "#9AA5E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M247.57 73.7109H255.936L272.569 107.772H264.203L247.57 73.7109Z",
    fill: "#F3F5FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.994 73.7109H261.539L278.171 107.772H275.627L258.994 73.7109Z",
    fill: "#F3F5FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M258.994 139.816C258.994 138.712 259.89 137.816 260.994 137.816H284.095C285.199 137.816 286.095 138.712 286.095 139.816V144.851C286.095 145.955 285.199 146.851 284.095 146.851H260.994C259.89 146.851 258.994 145.955 258.994 144.851V139.816Z",
    fill: "#353071"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M286.096 146.005V139.816C286.096 138.712 285.2 137.816 284.096 137.816H277.912L284.579 146.519C284.739 146.728 284.987 146.851 285.25 146.851C285.717 146.851 286.096 146.472 286.096 146.005Z",
    fill: "#120E47"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.555 140.23C260.555 139.678 261.002 139.23 261.555 139.23H283.536C284.089 139.23 284.536 139.678 284.536 140.23V144.438C284.536 144.991 284.089 145.438 283.536 145.438H261.555C261.002 145.438 260.555 144.991 260.555 144.438V140.23Z",
    fill: "#F3F5FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M284.536 144.938V140.23C284.536 139.678 284.089 139.23 283.536 139.23H279.031L283.771 145.438H284.036C284.312 145.438 284.536 145.215 284.536 144.938Z",
    fill: "#6762AA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239.254 140.23C239.254 139.678 239.702 139.23 240.254 139.23H250.215C250.767 139.23 251.215 139.678 251.215 140.23V144.438C251.215 144.991 250.767 145.438 250.215 145.438H240.254C239.702 145.438 239.254 144.991 239.254 144.438V140.23Z",
    fill: "#353071"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M266.178 144.376V140.234H267.734C268.683 140.234 269.189 140.812 269.192 141.607C269.189 142.399 268.677 142.974 267.722 142.974H266.921V144.376H266.178ZM266.921 142.362H267.619C268.18 142.359 268.432 142.045 268.432 141.607C268.432 141.164 268.18 140.858 267.619 140.858H266.921V142.362Z",
    fill: "#353071"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M270.016 144.422C269.77 144.422 269.567 144.221 269.57 143.975C269.567 143.735 269.77 143.538 270.016 143.535C270.253 143.538 270.456 143.735 270.456 143.975C270.456 144.221 270.253 144.422 270.016 144.422Z",
    fill: "#353071"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M271.194 144.376V140.234H272.75C273.7 140.234 274.206 140.812 274.209 141.607C274.206 142.399 273.694 142.974 272.739 142.974H271.938V144.376H271.194ZM271.938 142.362H272.636C273.196 142.359 273.448 142.045 273.448 141.607C273.448 141.164 273.196 140.858 272.636 140.858H271.938V142.362Z",
    fill: "#353071"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M275.507 140.234V144.376H274.775V140.234H275.507Z",
    fill: "#353071"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M277.584 144.439C276.649 144.439 276.074 143.815 276.074 142.843C276.074 141.882 276.657 141.23 277.544 141.23C278.305 141.23 278.962 141.707 278.962 142.797V143.026H276.795C276.806 143.555 277.118 143.87 277.59 143.867C277.91 143.87 278.124 143.732 278.219 143.546H278.934C278.802 144.084 278.305 144.439 277.584 144.439ZM276.797 142.528H278.265C278.262 142.105 277.976 141.796 277.555 141.796C277.118 141.796 276.823 142.133 276.797 142.528Z",
    fill: "#353071"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M293.873 140.23C293.873 139.678 294.321 139.23 294.873 139.23H304.834C305.387 139.23 305.834 139.678 305.834 140.23V144.438C305.834 144.991 305.387 145.438 304.834 145.438H294.873C294.321 145.438 293.873 144.991 293.873 144.438V140.23Z",
    fill: "#120E47"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 228.75,
    y: 90.8691,
    width: 3.92265,
    height: 1.35141,
    fill: "#353071"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.441 91.7422C224.441 91.1899 224.889 90.7422 225.441 90.7422H229.45C230.002 90.7422 230.45 91.1899 230.45 91.7422V98.7164C230.45 99.2687 230.002 99.7164 229.45 99.7164H225.441C224.889 99.7164 224.441 99.2687 224.441 98.7164V91.7422Z",
    fill: "#353071"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M224.904 92.3203C224.904 91.768 225.352 91.3203 225.904 91.3203H228.987C229.539 91.3203 229.987 91.768 229.987 92.3203V98.138C229.987 98.6903 229.539 99.138 228.987 99.138H225.904C225.352 99.138 224.904 98.6903 224.904 98.138V92.3203Z",
    fill: "#C3CCFB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M229.987 98.3537V98.1874C229.987 98.0162 229.94 97.8483 229.853 97.7012L226.269 91.679C226.137 91.4566 225.897 91.3203 225.638 91.3203C225.233 91.3203 224.904 91.649 224.904 92.0545V92.514C224.904 92.6972 224.955 92.8769 225.05 93.0335L228.532 98.7612C228.674 98.9952 228.929 99.138 229.202 99.138C229.636 99.138 229.987 98.7869 229.987 98.3537Z",
    fill: "#F3F5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_569_27156)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.994,
    y: 112.875,
    width: 27.1012,
    height: 1.61941,
    rx: 0.809707,
    fill: "#120E47"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258.994 113.422V113.654C258.994 114.118 259.37 114.494 259.834 114.494L258.994 113.422Z",
    fill: "#353071"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_569_27156)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.994,
    y: 116.281,
    width: 27.1012,
    height: 1.61941,
    rx: 0.809707,
    fill: "#120E47"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_569_27156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.484 116.281H259.804C259.357 116.281 258.994 116.644 258.994 117.091C258.994 117.538 259.357 117.901 259.804 117.901H262.473L261.661 116.857C261.379 116.494 260.944 116.281 260.484 116.281Z",
    fill: "#353071"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_569_27156)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.994,
    y: 119.691,
    width: 27.1012,
    height: 1.61941,
    rx: 0.809707,
    fill: "#120D47"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_569_27156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.251 119.691H259.804C259.357 119.691 258.994 120.054 258.994 120.501C258.994 120.948 259.357 121.311 259.804 121.311H265.105L264.817 120.943C264.2 120.153 263.254 119.691 262.251 119.691Z",
    fill: "#353071"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_569_27156",
    x: 258.994,
    y: 112.875,
    width: 27.1016,
    height: 1.81914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469945 0 0 0 0 0.0351389 0 0 0 0 0.183333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27156"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_569_27156",
    x: 258.994,
    y: 116.281,
    width: 27.1016,
    height: 1.82109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469945 0 0 0 0 0.0351389 0 0 0 0 0.183333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27156"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_569_27156",
    x: 258.994,
    y: 116.281,
    width: 3.47852,
    height: 1.82109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0704896 0 0 0 0 0.0523437 0 0 0 0 0.279167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27156"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_569_27156",
    x: 258.994,
    y: 119.691,
    width: 27.1016,
    height: 1.82109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469945 0 0 0 0 0.0351389 0 0 0 0 0.183333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27156"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_569_27156",
    x: 258.994,
    y: 119.691,
    width: 6.11133,
    height: 1.82109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0704896 0 0 0 0 0.0523437 0 0 0 0 0.279167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27156"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport05);
export default __webpack_public_path__ + "static/media/transport_05.66b614068c67af9103f4f849beee8209.svg";
export { ForwardRef as ReactComponent };